import React from 'react';
import style from './styles.module.css';
import LoadingSpin from '../LoadingSpin';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'default'
    | 'primary'
    | 'error'
    | 'text'
    | 'icon'
    | 'pagination'
    | 'menu'
    | 'menu-active'
    | 'stepper';
  backgroundColor?: string;
  size?: 'small' | 'medium' | 'large' | 'none';
  label?: string | React.ReactNode;
  loading?: boolean;
  icon?: React.ReactNode;
  iconStart?: React.ReactNode;
  iconEnd?: React.ReactNode;
  loadingColor?: string;
  loadingSize?: number;
  loadingThickness?: number;
}

export const Button = ({
  variant = 'default',
  size = 'medium',
  backgroundColor,
  label,
  icon,
  iconStart,
  iconEnd,
  loading,
  loadingColor,
  loadingThickness,
  loadingSize = 20,
  className,
  style: customStyle,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={`${style.button} ${style[size]} ${style[variant]} ${
        className || ''
      }`}
      style={{
        backgroundColor,
        justifyContent: loading ? 'center' : 'flex-start',
        ...customStyle,
      }}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? (
        <LoadingSpin
          size={loadingSize}
          color={loadingColor}
          thickness={loadingThickness}
        />
      ) : ['icon', 'pagination'].includes(variant) ? (
        icon && <span className={style.buttonIcon}>{icon}</span>
      ) : (
        <>
          {iconStart && <span className={style.buttonIcon}>{iconStart}</span>}
          {label}
          {iconEnd && <span className={style.buttonIcon}>{iconEnd}</span>}
        </>
      )}
    </button>
  );
};
